import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { header, Multipartheader } from "../../Components/Url/ApiUrl";
import swal from "sweetalert";
import {useTranslation} from "react-i18next";

const ImageUpload = () => {
    const {t} = useTranslation();
    const [images, setImages] = useState([]);
    const [newImage, setNewImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchImages = () => {
        axios.get(`${process.env.REACT_APP_API_ENDPOINT}/files/gallery`, { headers: header })
            .then(response => {
                if (response.data.images) {
                    setImages(response.data.images);
                }

            })
            .catch(error => {
                console.error('Rasmlarni olishda xatolik:', error);
            });
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif'];
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
        const maxSize = 5 * 1024 * 1024;

        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!allowedTypes.includes(file.type)) {
            await swal(t('translation:warning'), `${t('invalid_mime')}: ` + file.type, "warning");
            return;
        }

        if (!allowedExtensions.includes(fileExtension)) {
            await swal(t('translation:warning'), `${t('invalid_extention')}: .` + fileExtension, "warning");
            return;
        }

        if (file.size > maxSize) {
            await swal(t('translation:warning'), t('invalid_size'), "warning");
            return;
        }

        setNewImage(file);
        setPreviewUrl(URL.createObjectURL(file));
    };


    const handleSave = async () => {
        const formData = new FormData();
        formData.append("image", newImage);

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/company/company-services/gallery/0`,
                formData,
                { headers: Multipartheader }
            );

            if (res.data?.success) {
                await swal(t('saved'), `${t('translation:success')} ${t('added')}`, "success");
                setNewImage(null);
                setPreviewUrl(null);
                fetchImages();
            } else {
                const msg = res.data?.message;
                const firstError = typeof msg === 'object'
                    ? msg[Object.keys(msg)[0]]?.[0] || t('translation:error_occured')
                    : msg;
                await swal(t('error'), firstError, "error");
                setPreviewUrl(null)
                setNewImage(null);
            }
        } catch (err) {
            swal(t('error'), err.message || t('translation:unknown_error'), "error");
        }
    };

    const deleteImage = async (index) => {
        try {
            const confirmed = await swal({
                title: t('want_delete'),
                text: t('pic_will_be_delete'),
                icon: "warning",
                buttons: [t('translation:cancel'), t('translation:delete')],
                dangerMode: true,
            });

            if (confirmed) {
                const res = await axios.delete(
                    `${process.env.REACT_APP_API_ENDPOINT}/company/company-services/gallery/${index}`,
                    { headers: header }
                );
                if (res.data?.success) {
                    swal(t('deleted'), t('pic_deleted'), "success");
                    fetchImages();
                } else {
                    swal(t('error'), t('pic_not_deleted'), "error");
                }
            }
        } catch (err) {
            swal(t('error'), err.message, "error");
        }
    };

    return (
        <div className="d-flex flex-wrap align-items-start">
            {images.map((image, index) => (
                <div
                    key={index}
                    className="img-block m-2 position-relative"
                    style={{
                        backgroundImage: `url(data:image/png;base64,${image.img})`,
                        width: "150px",
                        height: "150px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "8px"
                    }}
                >
                    <div className="img-actions position-absolute top-0 end-0 p-1 d-flex gap-1">
                        <i className="bi bi-zoom-in text-light cursor-pointer fs-5"
                           onClick={() => {
                               setActiveIndex(index);
                               setModalOpen(true);
                           }}
                        ></i>
                        <i className="bi bi-trash text-danger cursor-pointer fs-5"
                           onClick={() => deleteImage(image.suffix)}></i>
                    </div>
                </div>
            ))}

            {/* Upload button */}
            <input
                type="file"
                accept='image/jpeg, image/png, image/jpg, image/webp, image/gif'
                id="imageUpload"
                onChange={handleImageChange}
                hidden
            />
            <label htmlFor="imageUpload" className="btn btn-outline-secondary btn-lg m-2">
                <i className="bi bi-plus-circle icon-3rem"></i>
            </label>


            {/* Modal preview */}
            {previewUrl && (
                <div className="modal d-block" tabIndex="-1" style={{background: "#000000cc"}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content p-3" style={{maxHeight:"100vh"}}>
                            <img src={previewUrl} alt="Preview" style={{
                                maxHeight: "85vh",
                                maxWidth: "100%",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                                display: "block",
                                margin: "0 auto"
                            }} className="mb-3 rounded"/>
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-danger" onClick={() => {
                                    setNewImage(null);
                                    setPreviewUrl(null);
                                }}>
                                    {t('translation:cancel')}
                                </button>
                                <button className="btn btn-success" onClick={handleSave}>
                                    {t('save')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {modalOpen && (
                <div className="modal d-block" tabIndex="-1" style={{background: "#000000cc"}}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content p-3 bg-dark text-light">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <button
                                    className="btn btn-light"
                                    onClick={() =>
                                        setActiveIndex((prev) => (prev - 1 + images.length) % images.length)
                                    }
                                >
                                    <i className="bi bi-arrow-left"></i>
                                </button>
                                <strong>{activeIndex + 1} / {images.length}</strong>
                                <button
                                    className="btn btn-light"
                                    onClick={() =>
                                        setActiveIndex((prev) => (prev + 1) % images.length)
                                    }
                                >
                                    <i className="bi bi-arrow-right"></i>
                                </button>
                            </div>

                            {/* Rasm */}
                            <img
                                src={`data:image/png;base64,${images[activeIndex]?.img}`}
                                alt="Modal"
                                id="zoomedImage"
                                className="img-fluid rounded"
                                style={{maxHeight: "70vh", objectFit: "contain", cursor: "zoom-in"}}
                                onClick={() => {
                                    const elem = document.getElementById("zoomedImage");
                                    if (elem.requestFullscreen) elem.requestFullscreen();
                                }}
                            />

                            <div className="d-flex justify-content-between mt-3">
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        deleteImage(images[activeIndex]?.suffix);
                                        setModalOpen(false);
                                    }}
                                >
                                    <i className="bi bi-trash3-fill"></i> {t('delete')}
                                </button>

                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setModalOpen(false)}
                                >
                                    {t('close')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default ImageUpload;
